<template>
	<div class="high-polymer-c"  :style="'overflow-x: hidden;background:'+bgColor">
		<div style="width: 1190px;    margin: 0 auto;">
			<div style="width: 1920px; height: 426px; overflow: hidden; margin-left: -357px;" class="banner-c"><img :src="bannerImage"></div>
			<!-- <div v-if="lang=='zh' || lang=='en'" style="width: 1920px;   height: 426px;overflow: hidden; margin-left: -357px;"><img src="../assets/images/gaofenzibanner.jpg"></div>
			<div v-if="lang=='ja'" style="width: 1920px;   height: 426px;overflow: hidden; margin-left: -357px;"><img src="../assets/images/gaofenzibannerja.jpg"></div>
			<div v-if="lang=='ko'" style="width: 1920px;   height: 426px;overflow: hidden; margin-left: -357px;"><img src="../assets/images/gaofenzibannerko.jpg"></div> -->
		</div>
		<div class="bread-c">
			<div class="item-c">
				<div v-if="lang=='zh'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页</div> > 高性能树脂事业部</div>
				<div v-if="lang=='en'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">home page </div> > High Performance Resin Business Department</div>
				<div v-if="lang=='ko'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">첫 페이지</div> >  고성능 수지 사업부</div>
				<div v-if="lang=='ja'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">最初のページ</div> > 高性能樹脂事業部</div>
			</div>
			
		</div>
		<div class="info-content">
			<div class="title-c">		
				<div class="title" v-html="detailCompanyInfo.title">
				</div>				
				<div class="line"></div>
			</div>
			
			<div class="content-c">
				<div v-html="detailCompanyInfo.content"></div>
			</div>
		</div>
		<div class="business-unit-bg">
			<div class="business-unit">
				<div class="title-c">
					<span v-if="lang=='zh'">产品中心</span>
					<span v-if="lang=='en'">Product Center</span>
					<span v-if="lang=='ko'">제품</span>
					<span v-if="lang=='ja'">製品センター</span>
					
					<!-- <template v-if="lang=='zh'">世界一流的树脂材料在我们这里生产</template>
					<template v-if="lang=='en'">World class resin materials are produced here</template>
					<template v-if="lang=='ko'">세계 일류 의 수지 재료 가 우리 에서 생산된다</template>
					<template v-if="lang=='ja'">世界一流の樹脂材料はこちらで生産しています</template> -->
				</div> 
				<!-- :to="{ path:'/businessDetail/'+lang ,query:{ id: business._id}}" -->
				<div  v-for="business in businessList" @click="goDetail(business)" class="business-c f-l" :style="'background:'+(business.bgColor||'#d2e8fc')">
					<div class="image-c" >
						<template v-if="!business.icoUrl">
							<span :class="getIcoName(business.icoKey)"></span>
						</template>
						<template v-if="business.icoUrl">
							<img :src="business.icoUrl" >
						</template>
					</div>
					<div class="bottom-c">{{business.productName}}</div>
				</div>
				<div class="clearfix"></div>
			</div>
		</div>
		<p-bottom :lang="lang"></p-bottom>
	</div>
</template>

<script>
	export default {
	  name: 'Bussniess',
	  props:{
		  lang:{},
	  },
	  data() {
	    return {
		  businessList:[],
		  imageConfig:{},
		  bannerImage:'',
		  detailCompanyInfo:{},
		  bgColor:'#fff'
	    }
	  },
	  methods: {
			handelBg(){
				if(localStorage.getItem('backgroudColor')){
					this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).company3BdColor
				}
			},
	      async fetch(){
	      	  const res=await this.$http.get('/highPolymerList');
			  console.log(res)
			  var listData=[];
			  var _this=this;
			  res.data.forEach((business)=>{
				  if(business.language==_this.lang){
					  listData.push(business)
				  }
			  })
	      	  this.businessList=listData;
	      	  this.getCompanyInfo()
	      },
		  async getImage(){
			const res=await this.$http.get('imageConfig')
			this.imageConfig = res.data[0]||{}
			this.bannerImage = this.imageConfig.thirdTabBanner
		  },
		  getIcoName(key){
			  var map={
				  1:"one",
				  2:"two",
				  3:"three",
				  4:"four",
				  5:"five",
				  6:"six",
				  7:"seven",
				  0:"zero",
			  }
			  return map[key];
		  },
		  goDetail(business){
		
				this.$router.push({
					path:'/businessDetail/'+this.lang,
					query:{
					id:business._id
					}
				}
				)
		  },
		  async getCompanyInfo(){
				const res  =  await this.$http.post('companyInfoList',{la:this.lang,type:2})
				this.detailCompanyInfo = res.data[0]||{}	
		  },
		//   goDetail(id){
		// 	  this.$router.push('/businessDetail/'+this.lang)
		// 	  localStorage.setItem('businessDetailData', JSON.stringify({id:id}))
		//   }
	
	  },
	  created(){
		  console.log(this.lang)
		  this.fetch()&&this.getImage()
		  this.handelBg()
	  },
	  watch: {
	  		// 如果路由有变化，会再次执行该方法
	  		"$route": "fetch"
	  }
	  
	}
</script>

<style>
	.high-polymer-c .info-content .title-c{
		width:1060px;
		margin: 90px auto 50px;
		text-align: center;
		font-size: 36px;
		color: #4f5152;
		position: relative;

	}
	.high-polymer-c .info-content .title-c .title{
		height: 50px;
        text-align: center;
		
	}
	.banner-c{
		position: relative;
	}
	.banner-c img{
		position: absolute;
		left:0;
		width:1920px;
		margin:0 calc(50% - 960px);
	}
	.high-polymer-c .info-content .title-c .line{
		width: 800px;
		height: 1px;
		background: #c7c7c7;
		left: 120px;
		top: 20px;
		position: absolute;
		z-index: -1;
	}
	.high-polymer-c .info-content .content-c{
		width: 1220px;
		margin: 0 auto;
		font-size: 16px;
		color: #999;
		line-height: 30px;
		padding-bottom: 100px;
		height: auto;
	}
	.high-polymer-c .business-unit-bg{
		width: 100%;
		background: #fafbff;
		padding-bottom: 30px;
	}
	.high-polymer-c .business-unit{
		width: 1190px;
		margin: 0 auto;
	}
	.high-polymer-c .business-unit .title-c{
		text-align: center;
		color: #999;
		padding: 40px;
	}
	.high-polymer-c .business-unit .title-c span{
		width: 100%;
		font-size: 36px;
		color: #333;
		margin: 0 0 18px 0 ;
		text-align: center;
		display: block;
	}
	.high-polymer-c .business-unit .business-c{
		width: 280px;
		height: 355px;
		display: block;
		background: #d2e8fc;
		border-radius: 12px;
		margin: 8px;
		position: relative;
		overflow: hidden;
	}
	
	.high-polymer-c .business-unit .business-c:hover{
		    -webkit-box-shadow: 0px 0px 6px rgba(0,0,0,.6);
		    box-shadow: 0px 0px 6px rgba(0,0,0,.6);
	}
	.high-polymer-c .business-unit .business-c:hover span
	{
		    cursor: pointer;
		    transform: scale(1.1);
		    -ms-transform:scale(1.1);     /* IE 9 */
		    -moz-transform:scale(1.1);     /* Firefox */
		    -webkit-transform:scale(1.1); /* Safari 和 Chrome */
		    -o-transform:scale(1.1);
	}
	.high-polymer-c .business-unit .business-c:hover img
	{
		    cursor: pointer;
		    transform: scale(1.1);
		    -ms-transform:scale(1.1);     /* IE 9 */
		    -moz-transform:scale(1.1);     /* Firefox */
		    -webkit-transform:scale(1.1); /* Safari 和 Chrome */
		    -o-transform:scale(1.1);
	}
	.high-polymer-c .business-unit .business-c .image-c{
		display: block;
		width: 165px;
		height: 176px;
		margin: 44px auto 0;
	}
	.high-polymer-c .business-unit .business-c .image-c img{
		display: block;
		width: 100%;
	}
	.high-polymer-c .business-unit .business-c span{
		display: block;
		width: 165px;
		height: 176px;
		margin: 44px auto 0;
	}
	.high-polymer-c .business-unit .business-c span.zero{
		background: url(../assets/images/high_polymer_ico.png) -21px 0 no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.one{
		background: url(../assets/images/high_polymer_ico.png) -213px -3px no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.two{
		background: url(../assets/images/high_polymer_ico.png) -423px -3px no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.three{
		background: url(../assets/images/high_polymer_ico.png) -16px -224px no-repeat;
		width: 153px;
	}
	.high-polymer-c .business-unit .business-c span.four{
		background: url(../assets/images/high_polymer_ico.png) -214px -226px no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.five{
		background: url(../assets/images/high_polymer_ico.png) -420px -229px no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.six{
		background: url(../assets/images/high_polymer_ico.png) -18px -453px no-repeat;
	}
	.high-polymer-c .business-unit .business-c span.seven{
		background: url(../assets/images/high_polymer_ico.png) -217px -460px no-repeat;
	}
	.high-polymer-c .business-unit .business-c .bottom-c{
		height: 98px;
		position: absolute;
		bottom: 0;
		background: #105588;
		border-bottom-left-radius:12px ;
		border-bottom-right-radius:12px ;
		width: 100%;
		text-align: center;
		font-size: 22px;
		color: #fff;
		padding-top:26px ;
	}
</style>
